module.exports = __webpack_public_path__ + "static/media/ZapytanieOfertowe2.b55dea53.pdf";